(function () {
  'use strict';
  var TTL = 30 * 60 * 1000;
  var KEY = 'skScannerEnquiry:v1';
  function init(doc, win, routes) {
    if (!routes || doc.__skIndustrial) return;
    doc.__skIndustrial = true;
    var productMap = routes.products;
    var pageMap = routes.pages;
    var intents = { quote: '見積もり', selection: '機種選定', demo: '実機デモ' };
    var currentKey = Object.keys(pageMap).find(function (k) { return pageMap[k] === win.location.pathname; });
    function valid(c) {
      return c && (c.product === 'general' || Object.hasOwn(productMap, c.product)) && Object.hasOwn(intents, c.intent) && Object.hasOwn(pageMap, c.source);
    }
    function read() {
      try {
        var saved = JSON.parse(win.sessionStorage.getItem(KEY));
        if (valid(saved) && typeof saved.at === 'number' && Date.now() - saved.at >= 0 && Date.now() - saved.at < TTL) return saved;
      } catch (_) { /* Enquiries work without browser storage. */ }
      return null;
    }
    function save(c) { try { win.sessionStorage.setItem(KEY, JSON.stringify(c)); } catch (_) { /* Optional context only. */ } }
    function allowed() {
      try { return !(win.Shopify && win.Shopify.designMode) && win.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
      catch (_) { return false; }
    }
    function emit(event, context) {
      if (!allowed() || !valid(context)) return false;
      // Enumerated product and route identifiers only. Never read contact values or query strings.
      var payload = { scanner_product_id: context.product, scanner_brand: context.product === 'general' ? 'general' : productMap[context.product].brand, scanner_intent: context.intent, scanner_source: context.source };
      try {
        if (typeof win.gtag === 'function') win.gtag('event', event, payload);
        else if (Array.isArray(win.dataLayer)) win.dataLayer.push(Object.assign({ event: event }, payload));
        else return false;
        return true;
      } catch (_) { return false; }
    }
    var viewSent = false;
    function view() {
      var root = doc.querySelector('[data-sk-scanner-product]');
      if (!viewSent && root && currentKey) viewSent = emit('scanner_product_view', { product: root.dataset.skScannerProduct, source: currentKey, intent: 'selection' });
    }
    var completion = null;
    function refreshAnalytics() { view(); if (completion) completion(); }
    view();
    doc.addEventListener('visitorConsentCollected', refreshAnalytics);
    win.addEventListener('load', refreshAnalytics);
    if (win.Shopify && typeof win.Shopify.loadFeatures === 'function' && !win.Shopify.customerPrivacy) {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) refreshAnalytics(); });
    }
    doc.addEventListener('click', function (event) {
      var a = event.target.closest && event.target.closest('a[data-sk-scanner-cta]');
      if (!a || !currentKey) return;
      var url = new URL(a.href, win.location.origin);
      if (url.origin !== win.location.origin || url.pathname !== '/pages/contact') return;
      var c = { product: url.searchParams.get('scanner'), intent: url.searchParams.get('intent'), source: url.searchParams.get('source') };
      if (!valid(c) || c.source !== currentKey) return;
      emit('scanner_cta_click', c);
    });
    doc.querySelectorAll('[data-sk-scanner-filter]').forEach(function (select) {
      var scope = select.closest('.sk-industrial');
      select.addEventListener('change', function () {
        var count = 0;
        scope.querySelectorAll('[data-sk-scanner-category]').forEach(function (card) {
          card.hidden = !!select.value && card.dataset.skScannerCategory !== select.value;
          if (!card.hidden) count++;
        });
        scope.querySelector('[data-sk-scanner-count]').textContent = count + '件';
      });
    });
    doc.querySelectorAll('[data-sk-scanner-compare-filter]').forEach(function (select) {
      var scope = select.closest('.sk-industrial');
      select.addEventListener('change', function () {
        var count = 0;
        scope.querySelectorAll('[data-sk-scanner-compare-brand]').forEach(function (card) {
          card.hidden = !!select.value && card.dataset.skScannerCompareBrand !== select.value;
        });
        scope.querySelectorAll('tbody tr').forEach(function (row) {
          var a = row.querySelector('a');
          var p = Object.values(productMap).find(function (x) { return a && x.path === a.getAttribute('href'); });
          row.hidden = !!select.value && (!p || p.brand !== select.value);
          if (!row.hidden) count++;
        });
        scope.querySelector('[data-sk-scanner-count]').textContent = count + '件';
      });
    });
    if (win.location.pathname !== '/pages/contact') return;
    var panel = doc.querySelector('[data-sk-contact-panel="pre"]');
    if (!panel) return;
    var form = panel.closest('form');
    var query = new URLSearchParams(win.location.search);
    var fromQuery = { product: query.get('scanner'), intent: query.get('intent'), source: query.get('source'), at: Date.now() };
    var stored = read();
    var response = panel.dataset.skContactResponse;
    var hash;
    try { hash = decodeURIComponent(win.location.hash.slice(1)); } catch (_) { hash = ''; }
    // Shopify exposes form response state to both contact forms. Only the submitted pre-purchase form qualifies.
    if (response === 'success' && stored && stored.submitted && hash === form.id) {
      var completed = false;
      completion = function () {
        if (completed || !allowed() || (typeof win.gtag !== 'function' && !Array.isArray(win.dataLayer))) return;
        var fresh = read();
        if (!fresh || !fresh.submitted) return;
        try {
          win.sessionStorage.removeItem(KEY);
          if (win.sessionStorage.getItem(KEY) !== null) return;
        } catch (_) { return; }
        completed = true;
        emit('scanner_enquiry_complete', fresh);
      };
      completion();
      return;
    }
    if (response === 'success') return;
    var context = valid(fromQuery) ? fromQuery : response === 'error' && hash === form.id ? stored : null;
    if (!context) return;
    context.submitted = false;
    var product = context.product === 'general' ? null : productMap[context.product];
    var note = doc.createElement('div'); note.className = 'sk-ind-context';
    function line(text) { var p = doc.createElement('p'); p.textContent = text; note.appendChild(p); }
    function hidden(name, value) { var input = doc.createElement('input'); input.type = 'hidden'; input.name = 'contact[' + name + ']'; input.value = value; note.appendChild(input); }
    line('ご相談の種類：' + intents[context.intent]);
    if (product) line('参照機種：' + product.brand + ' / ' + product.name);
    line('参照ページ：' + pageMap[context.source]);
    line('対象のサイズ・材質・必要精度は、分かる範囲で相談内容にご記入ください。');
    hidden('スキャナー相談種別', intents[context.intent]);
    hidden('参照ブランド', product ? product.brand : '未選択');
    hidden('参照機種', product ? product.name : '未選択');
    hidden('参照ページ', pageMap[context.source]);
    panel.insertBefore(note, panel.querySelector('.contact-fields'));
    var item = panel.querySelector('input[name="contact[商品に関するお問い合わせの場合は商品名をご記載ください]"]');
    if (item && !item.value && product) item.value = product.name;
    var started = false;
    panel.addEventListener('input', function () { if (!panel.disabled && !panel.hidden && !started) started = emit('scanner_form_start', context); });
    form.addEventListener('submit', function () {
      if (panel.disabled || panel.hidden) return;
      // This is a pending attempt, never a conversion. Completion needs Shopify's success response above.
      save({ product: context.product, intent: context.intent, source: context.source, at: Date.now(), submitted: true });
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { init: init };
  if (typeof document !== 'undefined') {
    function start() { init(document, window, window.skIndustrialRoutes); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();
